import { Controller } from "@hotwired/stimulus"

// Admin "edit question" form: reveal the Fabric-reference config block (source +
// optional cascade filter) only when the question type is fabric_reference.
export default class extends Controller {
  static targets = ["type", "fabricConfig"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isFabric = this.hasTypeTarget && this.typeTarget.value === "fabric_reference"
    this.fabricConfigTargets.forEach((el) => {
      el.hidden = !isFabric
    })
  }
}
